<div mat-dialog-title class="condensed">
    {{data.title}}
</div>

<mat-dialog-content>
    @if (data.text) {
        <p [innerHTML]="data.text"></p>
    }

    @if (data?.options?.length > 0) {
        <div>
            @for (option of data.options; track option) {
                <div
                    [style.background-color]="option.bgColor"
                    class="option"
                    (click)="optionClicked(option)"
                    [class.disabled]="option.disabled"
                >
                    <div class="d-flex align-center">
                        @if (option.icon) {
                            <i [class]="option.icon" class="mr-2"></i>
                        }
                        <div>
                            {{option.name}}
                            @if (option.subtext) {
                                <br/>
                            }
                            @if (option.subtext) {
                                <small>{{option.subtext}}</small>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-between pt-3">
    @if (data.cancel) {
        <button (click)="onNoClick()" mat-button>
            {{data.cancel}}
        </button>
    }
    <div class="spacer"></div>
    @if (data.confirm) {
        <button
            mat-raised-button
            [mat-dialog-close]="true"
            cdkFocusInitial
            color="primary"
        >
            {{data.confirm}}
        </button>
    }
</mat-dialog-actions>
